export default __webpack_public_path__ + "static/media/ZangXinForestMap.ea3505a5.jpg";